module.exports = __webpack_public_path__ + "media/images/career_camp/2023/stats_illustration_4-2b0d8ae93dbf4de2eaac368fb6dac992.svg";